// Event wall-clock timezone. Play-day times the admin enters (e.g. 11:00 AM)
// are EVENT-LOCAL. We render and edit every scheduled time in this zone so a
// match set for 11:00 AM always reads 11:00 AM in Admin AND View Mode,
// regardless of the viewer's own browser timezone. DST-safe (IANA zone).
export const EVENT_TZ = 'America/Los_Angeles';

// Offset (ms) of EVENT_TZ at a given UTC instant. Positive east of UTC.
function tzOffsetMs(utcMs, tz) {
  const dtf = new Intl.DateTimeFormat('en-US', {
    timeZone: tz, hourCycle: 'h23',
    year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', second: '2-digit',
  });
  const parts = dtf.formatToParts(new Date(utcMs));
  const map = {};
  parts.forEach((p) => { map[p.type] = p.value; });
  const asUTC = Date.UTC(
    +map.year, +map.month - 1, +map.day,
    +map.hour, +map.minute, +map.second,
  );
  return asUTC - utcMs;
}

// A date ('YYYY-MM-DD') + time ('HH:MM') the admin typed are EVENT-LOCAL
// wall-clock → the correct UTC ISO instant.
export function localPartsToIso(date, time) {
  if (!date) return null;
  const [y, mo, d] = date.split('-').map(Number);
  const [h, mi] = (time || '00:00').split(':').map(Number);
  if ([y, mo, d, h, mi].some((n) => Number.isNaN(n))) return null;
  const guess = Date.UTC(y, mo - 1, d, h, mi, 0);
  const offset = tzOffsetMs(guess, EVENT_TZ);
  return new Date(guess - offset).toISOString();
}

// A stored ISO instant → { date:'YYYY-MM-DD', time:'HH:MM' } in EVENT_TZ,
// for prefilling the schedule editor so it round-trips exactly.
export function isoToEventParts(iso) {
  if (!iso) return { date: '', time: '' };
  const dtf = new Intl.DateTimeFormat('en-CA', {
    timeZone: EVENT_TZ, hourCycle: 'h23',
    year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit',
  });
  const map = {};
  dtf.formatToParts(new Date(iso)).forEach((p) => { map[p.type] = p.value; });
  return { date: `${map.year}-${map.month}-${map.day}`, time: `${map.hour}:${map.minute}` };
}

export function fmtEventTime(iso) {
  if (!iso) return null;
  return new Date(iso).toLocaleTimeString('en-US', {
    timeZone: EVENT_TZ, hour: 'numeric', minute: '2-digit',
  });
}

export function fmtEventDate(iso) {
  if (!iso) return null;
  return new Date(iso).toLocaleDateString('en-US', {
    timeZone: EVENT_TZ, month: 'short', day: 'numeric',
  });
}

export function sameInstant(a, b) {
  if (!a && !b) return true;
  if (!a || !b) return false;
  return new Date(a).getTime() === new Date(b).getTime();
}
